import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['status', 'coachCardStatus', 'eventCardStatus']
  static values = { url: String, registrationUrl: String }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }

  async connect() {
    try {
      const response = await fetch(this.urlValue)
      const data = await response.json()

      if (data.registered) {
        if (this.hasStatusTarget) {
          this.statusTarget.textContent = 'Join Webinar'
          this.statusTarget.href = data.join_url
        }
        if (this.hasCoachCardStatusTarget) {
          this.coachCardStatusTarget.textContent = 'Join Webinar'
          this.coachCardStatusTarget.href = data.join_url
        }
        if (this.hasEventCardStatusTarget) {
          this.eventCardStatusTarget.textContent = 'Join Webinar'
          this.eventCardStatusTarget.href = data.join_url
        }
      } else {
        if (this.hasStatusTarget) {
          this.statusTarget.textContent = 'Register Now'
        }
        if (this.hasCoachCardStatusTarget) {
          this.coachCardStatusTarget.textContent = 'Register for Event'
        }
        if (this.hasEventCardStatusTarget) {
          this.eventCardStatusTarget.textContent = 'Register'
        }
      }
    } catch (error) {
      console.error('Error fetching registration status:', error)
    }
  }

  disableTarget(target) {
    target.disabled = true
    target.removeAttribute('href')
    target.tabIndex = -1
    target.setAttribute('aria-disabled', 'true')
    target.classList.add('cursor-not-allowed', 'opacity-50')
    target.removeAttribute('data-action')
  }

  async createRegistration() {
    try {
      const response = await fetch(this.registrationUrlValue, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': this.csrfToken(),
        },
      })

      const body = await response.json()

      if (response.status === 200) {
        if (this.hasStatusTarget) {
          this.statusTarget.textContent = 'Join Webinar'
          this.statusTarget.href = body.join_url
        }
        if (this.hasCoachCardStatusTarget) {
          this.coachCardStatusTarget.textContent = 'Join Webinar'
          this.coachCardStatusTarget.href = body.join_url
        }
        if (this.hasEventCardStatusTarget) {
          this.eventCardStatusTarget.textContent = 'Join Webinar'
          this.eventCardStatusTarget.href = body.join_url
        }
      } else if (response.status === 422 && body.errors) {
        alert(body.errors.join('\n'))
      } else {
        alert('An unexpected error occurred. Please try again later.')
      }
    } catch (error) {
      console.error('Error creating registration:', error)
      alert('An error occurred while registering. Please try again later.')
    }
  }
}
